import PageLayout from "../../../../_components/PageLayout";
import MyButton from "../../../../_components/MyButton";
import { Box, Stack, useTheme } from "@mui/material";
import { useSwiper } from "swiper/react";
import OrbitingLogos from "../../components/OrbitingLogos/OrbitingLogos";
import Text from "../../../../_components/Text";
import videoFile from "./StartEarningVideo.mp4";
import { APP_ID, route } from "../../../../_app/consts";
import useLocalStorage from "../../../../_hooks/useLocalStorage";

const StartEarning = () => {
  const theme = useTheme();

  const [hasCompleteOnboarding, setHasCompleteOnboarding] = useLocalStorage(`hasCompleteOnboarding${APP_ID}`);

  const swiper = useSwiper();
  const handleSlideNext = () => {
    setHasCompleteOnboarding(true);
    swiper.slideNext();
  }

  return (
    <PageLayout
      bottomButton={
        <MyButton to={route.bots} withPaper onClick={handleSlideNext}>
          Start creating
        </MyButton>
      }
    >
      <Box
        className="layout"
        sx={{
          backgroundColor: theme.myTheme.colors.bg,
          padding: "0 0 16px",
        }}
      >
        <Box height="400px" marginBottom="32px">
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          >
            <source src={videoFile} type="video/mp4" />
          </video>
        </Box>

        <Stack>
          <Text textAlign="center" variant="h2" mb="24px">
            Start earning
          </Text>
          <Text textAlign="center" variant="regular" mb="8px">
            Create your first Bot in a few steps.
          </Text>
        </Stack>
      </Box>
    </PageLayout>
  );
};

export default StartEarning;
